import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { BlankComponent } from './pages/blank/blank.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { SearchComponent } from './pages/search/search.component';
import { HomeComponent } from './pages/home/home.component';
import { VideoComponent } from './pages/video/video.component';
import { NonAuthGuard } from './guards/no-auth.guard';
import { ShowsComponent } from './pages/shows/shows.component';
import { ShowDetailsComponent } from './pages/show-details/show-details.component';
import { SettingsPageComponent } from './pages/settings-page/settings-page.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { WatchlistComponent } from './pages/watchlist/watchlist.component';
import { CanDeactivateGuard } from './guards/can-deactivate-guard';
import { LiveComponent } from './pages/live/live.component';
import { SpecialShowDetailsComponent } from './pages/special-show-details/special-show-details.component';
import { BrowseComponent } from './pages/browse/browse.component';
import { CreatorProfileComponent } from './pages/creator-profile/creator-profile.component';

const routes: Routes = [
    { path: '', component: LandingPageComponent, canActivate: [NonAuthGuard] },
    { path: 'login', component: LoginComponent, canActivate: [NonAuthGuard] },
    { path: 'signup', component: LoginComponent, data: { isSignUp: true }, canActivate: [NonAuthGuard] },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'video/:id', component: VideoComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    { path: 'shows', component: ShowsComponent, canActivate: [AuthGuard] },
    { path: 'shows/:id', component: ShowsComponent, canActivate: [AuthGuard] },
    { path: 'season/:seasonId', component: ShowDetailsComponent, canActivate: [AuthGuard] },
    { path: 'settings', component: SettingsPageComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    { path: 'search', component: SearchComponent, canActivate: [AuthGuard] },
    { path: 'coming-soon', component: ComingSoonComponent, canActivate: [AuthGuard] },
    { path: 'watchlist', component: WatchlistComponent, canActivate: [AuthGuard] },
    { path: 'live/:id', component: LiveComponent, canActivate: [AuthGuard] },
    { path: 'creators/:slug', component: CreatorProfileComponent, canActivate: [AuthGuard]},

    { path: 'browse', component: BrowseComponent, canActivate: [AuthGuard] },
    { path: 'latest-videos', component: SpecialShowDetailsComponent, canActivate: [AuthGuard] },
    { path: 'latest', component: SpecialShowDetailsComponent, canActivate: [AuthGuard] },
    { path: 'exclusive', component: SpecialShowDetailsComponent, canActivate: [AuthGuard] },
    { path: 'popular', component: SpecialShowDetailsComponent, canActivate: [AuthGuard] },
    { path: 'continue-watching', component: SpecialShowDetailsComponent, canActivate: [AuthGuard] },

    // used for reloading video
    { path: 'blank', component: BlankComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
